var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { Radio } from '@material-ui/core';
import classNames from 'classnames';
import React, { useState } from 'react';
import styles from './ResolutionSelector.module.css';
export var Resolution;
(function (Resolution) {
    Resolution[Resolution["ResubmitScripts"] = 0] = "ResubmitScripts";
    Resolution[Resolution["PrintWithBarcode"] = 1] = "PrintWithBarcode";
    Resolution[Resolution["PrintWithoutBarcode"] = 2] = "PrintWithoutBarcode";
})(Resolution || (Resolution = {}));
export var ResolutionSelector = function (props) {
    // Temp, replace with proper state once resolution behavior finalised.
    var _a = __read(useState(Resolution.ResubmitScripts), 2), resolution = _a[0], setResolution = _a[1];
    return (React.createElement(React.Fragment, null,
        React.createElement(ResolutionOption, { resolution: Resolution.ResubmitScripts, name: 'Resubmit medications', info: 'Send the patient\u2019s medication to the exchange.', active: resolution === Resolution.ResubmitScripts, onClick: setResolution, testId: "resolutions-resubmit-scripts" }),
        React.createElement(ResolutionOption, { resolution: Resolution.PrintWithBarcode, name: 'Print scripts', info: 'Provide patient with hard copy of the script.', active: resolution === Resolution.PrintWithBarcode, onClick: setResolution, testId: "resolutions-print" })));
};
var ResolutionOption = function (props) {
    var _a;
    var containerClasses = classNames(styles.resolutionSelector, (_a = {},
        _a[styles.active] = props.active,
        _a));
    return (React.createElement("div", { className: containerClasses, onClick: function () { return props.onClick(props.resolution); } },
        React.createElement("div", { className: styles.icon },
            React.createElement(Radio, { checked: props.active, value: props.resolution, "data-test-id": props.testId })),
        React.createElement("div", { className: styles.information },
            React.createElement("div", { className: styles.title }, props.name),
            React.createElement("div", { className: styles.info }, props.info))));
};
